import { createContext, useContext } from 'react';

const DetectedErrorsContext = createContext([]);
const useMatchingErrors = (matcher) => {
  const targetRef = {
    name: matcher.metadata?.name ?? "",
    namespace: matcher.metadata?.namespace ?? "",
    kind: matcher.kind,
    apiGroup: matcher.apiVersion
  };
  const errors = useContext(DetectedErrorsContext);
  return errors.filter((e) => {
    const r = e.sourceRef;
    return targetRef.apiGroup === r.apiGroup && targetRef.kind === r.kind && targetRef.name === r.name && targetRef.namespace === r.namespace;
  });
};

export { DetectedErrorsContext, useMatchingErrors };
//# sourceMappingURL=useMatchingErrors.esm.js.map
